import gql from 'graphql-tag';

const LINK_DSP_ADVERTISER = gql`
  mutation linkExistingDspAdvertiser($id: ID!, $dspAdvertiserId: String!) {
    updateOrg(
      data: {
        dataConfig: {
          upsert: {
            create: {
              dspAdvertiserId: $dspAdvertiserId
              reTargeting: false
              appIds: { set: [] }
            }
            update: { dspAdvertiserId: $dspAdvertiserId }
          }
        }
      }
      where: { id: $id }
    ) {
      id
      dataConfig {
        dspAdvertiserId
      }
    }
  }
`;

export default LINK_DSP_ADVERTISER;
